<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      label-position="top"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="承运商" prop="carrierCode">
            <dict-select
              clearable
              v-model="formData.carrierCode"
              :body="carrierParams"
              :url="carrierUrl"
              placeholder="请选择承运商"
              filterable
              :selectedLabel.sync="formData.carrierName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="司机" prop="driverCode">
            <dict-select
              clearable
              v-model="formData.driverCode"
              :body="driverParams"
              :url="driverUrl"
              placeholder="请选择司机"
              filterable
              :selectedLabel.sync="formData.driverName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号码" prop="vehicleCode">
            <dict-select
              clearable
              v-model="formData.vehicleCode"
              :body="vehicleParams"
              :url="vehicleUrl"
              placeholder="请选择车辆"
              filterable
              :selectedLabel.sync="formData.vehicleNo"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="承运商单号" prop="carrierBillNo">
            <el-input v-model="formData.carrierBillNo" :disabled="disabled">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="跟车员" prop="assistant">
            <el-input v-model="formData.assistant" :disabled="disabled">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="跟车员手机号" prop="assistantMobile">
            <el-input v-model="formData.assistantMobile" :disabled="disabled">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="formData.remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    v_formData: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      selectChargeUnit: { type: 'chargeUnit' },
      selectSplitCostModel: { type: 'splitCostModel' },
      formData: {
        carrierCode: '',
        carrierName: '',
        assistant: '',
        assistantMobile: '',
        carrierBillNo: '',
        oneWayKm: '',
        roundTripKm: '',
        dispatchByName: '',
        splitCostModel: '0',
        contractCarrierCode: '',
        contractCarrierNo: '',
        contractCarrierName: '',
        chargeUnit: '0',
        chargeQty: 0,
        basePrice: 0,
        payFreight: 0,
        payFee: 0,
        payAmount: 0,
        contractFreight: 0,
        contractFee: 0,
        contractAmount: 0,
        driverName: '',
        vehicleNo: '',
      },
      // 下拉组件默认请求体地址
      driverUrl: '/master/driver/info/select',
      driverParams: {},
      vehicleUrl: '/master/vehicle/info/select',
      vehicleParams: {},
      carrierUrl: '/master/carrier/info/select',
      carrierParams: {},
      rules: {
        carrierCode: [{ required: true, message: ' ', trigger: 'change' }],
      },
    }
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData) {
          this.load()
        }
      },
      immediate: true,
    },
    v_formData: {
      handler(v_formData) {
        if (v_formData) {
          this.formData.carrierCode = v_formData.carrierCode
          this.formData.contractCarrierCode = v_formData.contractCarrierCode
          this.formData.contractCarrierNo = v_formData.contractCarrierNo
          this.formData.contractCarrierName = v_formData.contractCarrierName
          this.formData.chargeUnit = v_formData.chargeUnit
          this.formData.chargeQty = v_formData.chargeQty
          this.formData.basePrice = v_formData.basePrice
          this.formData.payFreight = v_formData.carrierFreight
          this.formData.payFee = v_formData.carrierFee
          this.formData.payAmount = v_formData.carrierAmount
          this.formData.contractFreight = v_formData.carrierFreight
          this.formData.contractFee = v_formData.carrierFee
          this.formData.contractAmount = v_formData.carrierAmount
        } else {
          this.formData.contractCarrierCode = ''
          this.formData.contractCarrierNo = ''
          this.formData.contractCarrierName = ''
          this.formData.chargeUnit = ''
          this.formData.chargeQty = 0
          this.formData.basePrice = 0
          this.formData.payFreight = 0
          this.formData.payFee = 0
          this.formData.payAmount = 0
          this.formData.contractFreight = 0
          this.formData.contractFee = 0
          this.formData.contractAmount = 0
        }
      },
      immediate: true,
      deep: true,
    },
    // 侦听承运商，修改司机
    'formData.carrierCode'() {
      const carrierCode = this.formData.carrierCode
      const vehicleCode = this.formData.vehicleCode
      const driverCode = this.formData.driverCode
      if (!carrierCode && !vehicleCode && !driverCode) {
        this.driverUrl = '/master/driver/info/select'
        this.driverParams = {}

        this.vehicleUrl = '/master/vehicle/info/select'
        this.vehicleParams = {}
      } else {
        this.driverUrl = '/master/vehicle/driver/driverListByVehicleAndCarrier'
        this.driverParams = {
          vehicleCode: vehicleCode,
          carrierCode: carrierCode,
        }

        this.vehicleUrl = '/master/vehicle/driver/vehicleListByDriverAndCarrier'
        this.vehicleParams = {
          driverCode: driverCode,
          carrierCode: carrierCode,
        }
      }
    },
    // 侦听司机，修改承运商，车牌号
    'formData.driverCode'() {
      const carrierCode = this.formData.carrierCode
      const driverCode = this.formData.driverCode
      const vehicleCode = this.formData.vehicleCode
      if (!driverCode) {
        if (!vehicleCode){
          this.carrierUrl = '/master/carrier/info/select'
          this.carrierParams = {}
        }else{
          this.carrierUrl = '/master/vehicle/info/selectCarrierBy'
          this.carrierParams = { vehicleCode: vehicleCode }
        }
        
        if (!carrierCode){
          this.vehicleUrl = '/master/vehicle/info/select'
          this.vehicleParams = {}
        }else{
          this.vehicleUrl = '/master/vehicle/driver/vehicleListByDriverAndCarrier'
          this.vehicleParams = { 
            carrierCode: carrierCode,
          }
        }
      } else {
        this.carrierUrl = '/master/driver/info/selectCarrierBy'
        this.carrierParams = { driverCode: driverCode }

        this.vehicleUrl = '/master/vehicle/driver/vehicleListByDriverAndCarrier'
        this.vehicleParams = { 
          carrierCode: carrierCode,
          driverCode: driverCode 
        }
      }
    },
    'formData.vehicleCode'() {
      const carrierCode = this.formData.carrierCode
      const vehicleCode = this.formData.vehicleCode
      const driverCode = this.formData.driverCode
      if (!vehicleCode) {
        if (!driverCode){
          this.carrierUrl = '/master/carrier/info/select'
          this.carrierParams = {}
        }else{
          this.carrierUrl = '/master/driver/info/selectCarrierBy'
          this.carrierParams = { driverCode: driverCode }
        }

        if (!carrierCode){
          this.driverUrl = '/master/driver/info/select'
          this.driverParams = {}
        }else{
          this.driverUrl = '/master/vehicle/driver/driverListByVehicleAndCarrier'
          this.driverParams = {
            carrierCode: carrierCode,
          }
        }
      } else {
        this.carrierUrl = '/master/vehicle/info/selectCarrierBy'
        this.carrierParams = { vehicleCode: vehicleCode }

        this.driverUrl = '/master/vehicle/driver/driverListByVehicleAndCarrier'
        this.driverParams = {
          vehicleCode: vehicleCode,
          carrierCode: carrierCode,
        }
      }
    },
    'formData.splitCostModel'() {
      this.formData.payAmount = this.totAmount
      this.$eventBus.$emit('splitCostModelChange', this.formData)
    },
    'formData.orderFreight'() {
      this.formData.payAmount = this.totAmount
      this.$eventBus.$emit('splitCostModelChange', this.formData)
    },
    'formData.orderFee'() {
      this.formData.payAmount = this.totAmount
      this.$eventBus.$emit('splitCostModelChange', this.formData)
    },
  },
  computed: {
    totAmount: {
      get() {
        let total = 0
        let freight = this.formData.payFreight ? this.formData.payFreight : 0
        let fee = this.formData.payFee ? this.formData.payFee : 0
        total = Number(freight) + Number(fee)
        return total
      },
      set(val) {
        this.formData.payAmount = val
      },
    },
  },
  methods: {
    load() {},
    getOneWayKm() {},
    getRoundTripKm() {},
    getCurCarrierCode() {
      return this.formData.carrierCode
    },
    async getCarrierData() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      return this.formData
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
